module.exports = __webpack_public_path__ + "static/media/default_coastview.7193294b.jpeg";